exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body .ui-datatable .ui-datatable-thead>tr>th .ui-column-title{display:block}td>span.ui-column-title{display:none!important}", ""]);

// exports
